import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const CustomToaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      className="toaster group"
      closeButton
      expand={false}
      position="bottom-right"
      richColors
      style={
        {
          '--normal-bg': 'hsl(var(--card))',
          '--normal-text': 'hsl(var(--foreground))',
          '--normal-border': 'hsl(var(--border))',
          '--success-bg': 'hsl(var(--card))',
          '--success-text': 'hsl(var(--foreground))',
          '--success-border': 'hsl(var(--border))',
          '--error-bg': 'hsl(var(--card))',
          '--error-text': 'hsl(var(--foreground))',
          '--error-border': 'hsl(var(--border))',
          '--warning-bg': 'hsl(var(--card))',
          '--warning-text': 'hsl(var(--foreground))',
          '--warning-border': 'hsl(var(--border))',
          '--info-bg': 'hsl(var(--card))',
          '--info-text': 'hsl(var(--foreground))',
          '--info-border': 'hsl(var(--border))',
        } as React.CSSProperties
      }
      theme={theme as ToasterProps['theme']}
      toastOptions={{
        duration: 2000, // Shorter duration for better UX
        classNames: {
          toast: `
            backdrop-blur-xl
            border border-border
            bg-card
            text-foreground
            shadow-2xl
            rounded-2xl
            p-3
            sm:p-4
            mb-2
            sm:mb-3
            mx-3
            sm:mx-4
            md:mx-0
            md:mb-4
            transition-all
            duration-200
            ease-out
            transform
            group-[&[data-state="closed"]]:animate-out
            group-[&[data-state="closed"]]:fade-out-80
            group-[&[data-state="closed"]]:slide-out-to-right-full
            group-[&[data-state="open"]]:animate-in
            group-[&[data-state="open"]]:fade-in-0
            group-[&[data-state="open"]]:slide-in-from-bottom-full
            md:group-[&[data-state="open"]]:slide-in-from-right-full
            sm:left-1/2 sm:-translate-x-1/2 sm:right-auto
            md:left-auto md:translate-x-0 md:right-4
            bottom-4
            sm:bottom-4
            md:bottom-4
            left-3
            right-3
            sm:left-auto sm:right-4
          `,
          description: 'text-foreground/80 text-xs sm:text-sm md:text-base',
          actionButton: `
            bg-primary
            text-primary-foreground
            rounded-lg
            px-2
            py-1
            sm:px-3
            sm:py-1.5
            text-xs
            sm:text-sm
            font-medium
            transition-colors
            hover:bg-primary/90
            focus:outline-none
            focus:ring-2
            focus:ring-primary/50
            touch-action-manipulation
          `,
          cancelButton: `
            bg-muted
            text-muted-foreground
            rounded-lg
            px-2
            py-1
            sm:px-3
            sm:py-1.5
            text-xs
            sm:text-sm
            font-medium
            transition-colors
            hover:bg-muted/80
            focus:outline-none
            focus:ring-2
            focus:ring-muted/50
            touch-action-manipulation
          `,
          icon: 'text-base sm:text-lg md:text-xl',
          title: 'font-semibold text-sm sm:text-base md:text-lg',
        },
      }}
      {...props}
    />
  );
};

export { CustomToaster };
